import React, { useState } from "react";
import PageLayout from "../../Components/Common/PageLayout";
import CardLayout from "../../Components/Common/CardLayout";
import HorizontalTabs from "../../Components/Common/HorizontalTabs";

import Commments from "./Comments";
import PreviousOrders from "./PreviousOrders";
import PreviousTickets from "./PreviousTickets";
import OrderHistory from "./OrderHistory";
import CustomerCart from "../admin/customer/CustomerCart"
const BottomTabs = ({ previousorderdata, previousticketsdata, OrderHistorydata,cartid }) => {
   

    const [justifyPillsTab, setjustifyPillsTab] = useState(1);

    const justifyPillsToggle = (tab) => {
        if (justifyPillsTab !== tab) {
            setjustifyPillsTab(tab);
        }
    };



    const tabs_data = [

        {
            id: 1,
            title: 'Order History',
            component: <OrderHistory setjustifyPillsTab={setjustifyPillsTab} previousorderdata={OrderHistorydata} />
        },
        {
            id: 2,
            title: 'Previous Orders',
            component: <PreviousOrders previousorderdata={previousorderdata?.data?.[0]} />
        },
        {
            id: 3,
            title: 'Tickets',
            component: <PreviousTickets previousticketsdata={previousticketsdata} />
        },
        {
            id: 4,
            title: 'Cart',
            component: <CustomerCart  custid={cartid}/>
        }
    ].filter(Boolean);


    return (

        <CardLayout heading={'Additional Details'}>
            <HorizontalTabs tabs_data={tabs_data} justifyPillsTab={justifyPillsTab} justifyPillsToggle={justifyPillsToggle} />
        </CardLayout>

    );
};

export default React.memo(BottomTabs);